import type { TPortfolio } from '@dekafvv/sharedfrontend';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialPayOutState } from './data';
import type {
    TAnswers, TExAnte, TIban, TPendingOrdersAmount, TValidations,
} from './types';

const initialState = initialPayOutState;

export const payOutSlice = createSlice({
    name: 'payOut',
    initialState,
    reducers: {
        setAnswers: (state, action: PayloadAction<Partial<TAnswers>>) => ({
            ...state,
            answers: {
                ...state.answers,
                ...action.payload,
            },
        }),
        setPayOutPortfolio: (state, action: PayloadAction<TPortfolio>) => ({
            ...state,
            portfolio: {
                ...action.payload,
            },
        }),
        setPayOutValidations: (state, action: PayloadAction<TValidations>) => ({
            ...state,
            validations: action.payload,
        }),
        setExAntePayOut: (state, action: PayloadAction<TExAnte>) => ({
            ...state,
            exAntePayOut: action.payload,
        }),
        setIban: (state, action: PayloadAction<TIban>) => ({
            ...state,
            iban: action.payload,
        }),
        setPendingOrdersAmount: (state, action: PayloadAction<TPendingOrdersAmount>) => ({
            ...state,
            pendingOrdersAmount: action.payload,
        }),
    },
});
